import { render, staticRenderFns } from "./block1.vue?vue&type=template&id=4a4f1834&scoped=true"
var script = {}
import style0 from "./block1.vue?vue&type=style&index=0&id=4a4f1834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4f1834",
  null
  
)

export default component.exports